import { FaMicrophoneAlt, FaClock, FaUsers, FaDollarSign } from 'react-icons/fa';

const features = [
    {
        id: 1,
        icon: <FaMicrophoneAlt />, // 麥克風圖示，代表精彩演講
        title: 'STEAM 機器人',
        description: '最具創意與創新的機器人競賽',
    },
    {
        id: 2,
        icon: <FaClock />, // 時鐘圖示，代表全年無休支持
        title: '國際化',
        description: '來自超過 6 個國家的支持與參與',
    },
    {
        id: 3,
        icon: <FaUsers />, // 使用者圖示，代表交流與社群
        title: '全齡參與',
        description: '設有少年組、青少年組與公開組，歡迎 8 歲以上參加 WRG',
    },
    {
        id: 4,
        icon: <FaDollarSign />, // 美元符號圖示，代表優惠與價值
        title: 'AI 機器人',
        description: '2025 年主題：將 AI 運算能力融入機器人競賽',
    },
];

export default features;
